export default __webpack_public_path__ + "static/media/bluetooth.c4c08447.svg";